<template>
  <div class="annex">
    <div class="grid-contain dialog edit">
      <div style="margin-bottom: 20px">
        <el-button v-permission="'1304'" type="primary" size="small" icon="el-icon-upload2"
                   @click="uploadFileDesc = !uploadFileDesc">上传文件
        </el-button>
        <el-button v-permission="'1303'" type="danger" size="small" icon="el-icon-delete"
                   @click="annexDelete">删除
        </el-button>
      </div>
      <div class="grid-table">
        <sp-table
          ref="batchTable"
          @selection-change="handleSelectionChange"
          :parentTableData.sync="annexDetailList"
          :parentCol.sync="enclosureAction">
          <el-table-column align="center" type="selection" class="selection"></el-table-column>
          <el-table-column align="center" label="序号"  type="index" width="50"/>
          <sp-table-column v-for="(item, index) in enclosureAction" :key="index" :width="item.width">
            <template slot="header">
                <p>{{item.title}}</p>
              </template>
            <template v-slot="{ scope }">
              <div class="span" v-if="item.field !== 'edit'">
                <p>{{scope.row[enclosureAction[index].field]}}</p>
              </div>
              <div class="span" v-else>
                <el-button type="primary" size="small" @click="fileDownload(scope.row)">下载</el-button>
                <!--<el-button type="primary" size="small">删除</el-button>-->
              </div>
            </template>
          </sp-table-column>
        </sp-table>
      </div>
      <div class="page">
        <page-modle :currentPage.sync="currentPage" :total="total" :pageSize.sync="pageSize"
                    @currentChange="currentChange" @sizeChange="sizeChange"/>
      </div>
    </div>
    <Dialog title="上传文件说明" :width="500" :height="100" :visible="uploadFileDesc"
            @close="uploadFileDesc = !uploadFileDesc">
      <div class="grid-contain dialog edit">
        <el-form style="margin-top: 20px" label-width="80px">
          <el-form-item label="文件说明">
            <el-input v-model="desc"  placeholder="请输入说明后再选择文件"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-upload
            class="upload-demo"
            action=""
            name="file"
            :show-file-list="false"
            :http-request="beforeAvatarUpload">
            <el-button size="small" icon="el-hg-icon-save" type="primary">选择文件</el-button>
          </el-upload>
          <el-button size="small" icon="el-hg-icon-close" type="danger" @click="uploadFileDesc = !uploadFileDesc"
                     style="margin-left: 20px">关 闭
          </el-button>
        </div>
      </div>
    </Dialog>

  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Dialog from '@/components/dialog';
  import dayjs from 'dayjs';
  import {spTable, spTableColumn} from '@/components/sptable';
  import pageModle from '@/views/comm/pagination';

  export default {
    name: 'annex',
    data() {
      return {
        annexDetailList: [],
        uploadFileDesc: false,
        desc: '',
        userChoice: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };
    },
    components: {
      spTable,
      spTableColumn,
      Dialog,
      pageModle
    },
    created() {
      this.annexSearchAPI();
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
      }),
      // buttonShow() {
      //   return this.userInfor.userType == 0
      // },
      enclosureAction() {
        return [
          {width: 160, title: '附件描述', field: 'explain'},
          {width: 160, title: '附件名称', field: 'annexname'},
          {width: 160, title: '添加人', field: 'operatorid'},
          {width: 160, title: '添加时间', field: 'adddate'},
          {width: 160, title: '编辑', field: 'edit'},
        ]
      },
    },
    methods: {
      handleSelectionChange(val) {
        this.userChoice = val;
      },
      // page翻页回调
      currentChange(val) {
        this.currentPage = val;
        this.annexSearchAPI();
      },
      // 每页显示数据内容变化
      sizeChange(val) {
        this.pageSize = val;
        this.annexSearchAPI();
      },
      // 附件上传前的钩子
      beforeAvatarUpload(file) {
        if (this.desc) {
          this.annexUploadAPI(file);
        }
        else {
          this.$message({
            message: '请填写上传附件的说明',
            type: 'warning',
          });
        }
        return false;
      },
      // 附件删除
      annexDelete() {
        this.userChoice.forEach(itme => {
          this.$services.post({
            type: 'ERP',
            url: 'annexRemove',
            params: {
              accountId: this.userInfor.accountId,
              tableId: 'System',
              billsId: '',
              listId: itme.listid,
              showIndex: itme.showindex
            }
          }).then(res => {
            if (typeof res.bean === 'string' && res.bean !== '') {
              let bean = JSON.parse(res.bean);
              if (bean.RetMessage) {
                this.$message({
                  message: JSON.parse(res.bean).RetMessage,
                  type: 'warning',
                });
              }
            }
            else if (res.code === '000') {
              this.$message({
                message: '删除成功！',
                type: 'success',
              });
            }
            this.annexSearchAPI();
          });

        })
      },
      // 单据的附件详情查询
      annexSearchAPI() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'annexSearch',
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            accountId: this.userInfor.accountId,
            tableId: 'System',
            billsId: ''
          },
        }).then(res => {
          this.annexDetailList = res.bean.list;
          this.total = res.bean.total;
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
          });
        });
      },
      // 单据附件的下载
      fileDownload(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexDownload',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'System',
            billsId: '',
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.$utils.downLoad(res, itme.annexname)
        });
      },
      //单据附件上传
      annexUploadAPI(file) {
        let listid = 0;
        if (this.annexDetailList.length > 0) {
          this.annexDetailList.forEach(itme => {
            if (listid < itme.listid) {
              listid = itme.listid;
            }
          });
        }
        let data = {
          updateFlg: 'add',
          accountid: this.userInfor.accountId,
          tableid: 'System',
          billsid: '',
          // listid: listid + 1,
          // showindex: listid + 1,
          explain: this.desc,
          annexname: file.file.name,
          operatorid: this.userInfor.userName,
          adddate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          annexsize: file.file.size / 1000,
        };
        this.$services.postUrlParams({
          type: 'ERP',
          url: 'annexUpload',
          urlParams: data,
          params: file.file,
        }).then(res => {
          if (res.code === '000') {
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          }
          this.uploadFileDesc = false;
          this.desc = '';
          this.annexSearchAPI();
        });
      },
    }

  };
</script>
<style lang="scss">
  .annex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;

    .page {
      height: 50px;
    }
  }

</style>
